export default "__VITE_ASSET__AmotQqi8__"